import { Block, Flex, Typography, colors } from '@aloft/toolkit-sui';
import { useAuth0 } from '@auth0/auth0-react';

import { useState } from 'react';
import { useNavigate } from 'react-router';

import { getBaseUrl } from '../../hooks/api/getBaseUrl.ts';
import { MainLayout } from '../../layout/MainLayout.tsx';
import { Section } from './Section.tsx';
import { SectionButton } from './SectionButton.tsx';
import { ImageAnalysisContent } from './imageAnalysis/ImageAnalysisContent.tsx';
import { RegresssionModelling } from './regression/RegressionModelling.tsx';
import { SectionID } from './types.ts';
import { UserManagementContent } from './userManagement/UserManagementContent.tsx';

export const AdminModule = () => {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [activeSectionID, setActiveSectionID] = useState<SectionID>('users');
  const openJobQueues = async () => {
    const response = await window.fetch(`${getBaseUrl()}/api/v2/admin/dashboard-session`, {
      method: 'POST',
      credentials: 'include',
      headers: { Authorization: `Bearer ${await getAccessTokenSilently()}` },
    });
    if (response.ok) window.location.assign(`${getBaseUrl()}/admin/queues`);
  };

  return (
    <MainLayout
      title="Appraiser Toolkit"
      showBackButton
      showNav={false}
      onBackButtonClick={() => navigate('/')}
    >
      <Block
        className="account-module"
        width="100%"
        height="100%"
        padding="16px"
        backgroundColor="surface2"
        overflow="auto"
      >
        <Flex className="container" gap="16px">
          <Flex
            className="section-menu"
            backgroundColor="surface1"
            padding="16px 8px"
            borderRadius="4px"
            flexDirection="column"
            justifyContent="flex-start"
            gap={8}
            minWidth="350px"
          >
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Admin</Typography>
              </Block>
              <SectionButton
                sectionID="users"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
            </Flex>
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Tools</Typography>
              </Block>
              <SectionButton
                sectionID="regression"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
              <SectionButton
                sectionID="imageAnalysis"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
            </Flex>
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Dev</Typography>
              </Block>
              <button
                onClick={openJobQueues}
                type="button"
                style={{ display: 'flex', padding: '10px 8px', borderRadius: '4px' }}
              >
                <Typography variant="h3" color="textSecondary">
                  Job queues
                </Typography>
              </button>
            </Flex>
          </Flex>
          <Block
            className="section-content"
            backgroundColor="surface1"
            padding="16px"
            borderRadius="4px"
          >
            <Section activeSectionID={activeSectionID} sectionID="users">
              <UserManagementContent />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="regression">
              <RegresssionModelling />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="imageAnalysis">
              <ImageAnalysisContent />
            </Section>
          </Block>
        </Flex>
      </Block>
    </MainLayout>
  );
};
